import { useGetBuyerSpendingLimitRequest } from '../../../../api/lending/lapiHooks';
import SpendingLimitView from '../SpendingLimitView/SpendingLimitView';

export const NoPlansView = ({
  setIsSpendingLimitDrawerOpen,
  loadingRefreshSpendingLimit,
  refreshSpendingLimit,
}: {
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refreshSpendingLimit: () => void;
  loadingRefreshSpendingLimit: boolean;
}) => {
  const { spendingLimitRequest, loadingSpendingLimitRequest } =
    useGetBuyerSpendingLimitRequest();

  if (loadingSpendingLimitRequest) return null;

  return spendingLimitRequest?.data?.uuid ? (
    <SpendingLimitView
      setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
      loadingRefreshSpendingLimit={loadingRefreshSpendingLimit}
      refreshSpendingLimit={refreshSpendingLimit}
    />
  ) : null;
};
